module.exports = __webpack_public_path__ + "img/组 496@2x.17a628f1.png";